import {ErrorCode} from 'react-dropzone'
import {useTranslation} from 'react-i18next'

export const useErrorCodes = () => {
  const {t} = useTranslation()

  const errorCodes: {[code: string]: string} = {
    'token-invalid': t('error_codes_your_token_was_invalid'),
    'token-expired': t('error_codes_your_token_has_expired'),
    'field-is-required': t('error_codes_required_field_is_empty'),
    'field-not-provided': t('error_codes_required_field_is_empty'),
    'invalid-email': t('error_codes_this_does_not_look_like'),
    'account-already-setup': t('error_codes_your_account_has_already_been'),
    'not-employed': t('error_codes_according_to_our_records_you'),
    'permission-denied': t('error_codes_current_password_is_incorrect'),
    'user-not-logged-in': t('error_codes_you_are_not_logged_in'),
    'private-email-not-set': t('error_codes_you_do_not_have_private'),
    [ErrorCode.FileInvalidType]: t('error_codes_unsupported_file_type'),
    [ErrorCode.FileTooLarge]: t('error_codes_file_too_large'),
    [ErrorCode.FileTooSmall]: t('error_codes_file_too_small'),
    [ErrorCode.TooManyFiles]: t('error_codes_too_many_files'),
    'one-or-more-documents-not-processed': t(
      'error_codes_one_or_more_documents_were'
    ),
    'no-documents-received': t('error_codes_no_documents_were_received'),
    'no-document-or-reason-received': t(
      'error_codes_no_documents_were_received_and'
    ),
    'service-unavailable': t(
      'error_codes_service_is_temporarily_not_available'
    ),
    'no-such-category': t('error_codes_chosen_category_is_unknown_to'),
    'invalid-file-type': t('error_invalid_file_type'),
  }

  return (code: string) =>
    errorCodes[code] ? errorCodes[code] : t('error_codes_unknown_error')
}
